import productIDS from './utils/products';

const discountCode = '9RtkVfmnRE#UwXmN$HQU';

exports.onClientEntry = () => {
  document.addEventListener('snipcart.ready', () => {
    Snipcart.subscribe('item.added', () => checkDiscount());
    Snipcart.subscribe('item.removed', () => checkDiscount());
  });
};

function checkDiscount() {
  let hasJersey = false;
  let hasShorts = false;
  let hasBaselayer = false;

  Snipcart.api.items.all().map((item) => {
    hasJersey = hasJersey || productIDS.jersies.includes(item.id);
    hasShorts = hasShorts || productIDS.shorts.includes(item.id);
    hasBaselayer = hasBaselayer || productIDS.baselayers.includes(item.id);
  });
  if (hasJersey && hasShorts && hasBaselayer) {
    let hasDiscount = false;
    Snipcart.api.discounts.all().map((discount) => {
      if (discount.code == discountCode) {
        hasDiscount = true;
      }
    });
    if (!hasDiscount) {
      Snipcart.api.discounts
        .applyDiscountCode(discountCode)
        .then((code) => {
          console.log('discount add');
        })
        .fail((error) => {
          console.log('Something went wrong when adding the discount?', error);
        });
    }
  } else {
    Snipcart.api.discounts.all().map((discount) => {
      if (discount.code == discountCode) {
        Snipcart.api.discounts
          .remove(discount.id)
          .then((discount) => {
            console.log('The discount has been removed', discount.id);
          })
          .fail((error) => {
            console.log('Something went wrong when removing the discount', error);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./gatsby-browser.js